import {
  ADD_BOARD_CORRESPONDENCE,
  DELETE_BOARD_CORRESPONDENCE,
  EDIT_BOARD_CORRESPONDENCE,
  GET_BOARD_CONTRACTS,
  GET_BOARD_EXPIRING_CONTRACTS,
  GET_CORRESPONDENCE,
  GET_CORRESPONDENCE_CATEGORIES,
} from "./CorrespondenceType";

export const CorrespondenceReducer = (
  state = {
    Categories: [],
    Correspondences: [],
    TasksCorrespondences: [],
    Contracts: [],
    ExpiringContracts: [],
  },
  action
) => {
  switch (action.type) {
    case GET_CORRESPONDENCE_CATEGORIES: {
      return {
        ...state,
        Categories: action.Payload,
      };
    }
    case GET_BOARD_CONTRACTS: {
      return {
        ...state,
        Contracts: action.Payload,
      };
    }
    case GET_BOARD_EXPIRING_CONTRACTS: {
      return {
        ...state,
        ExpiringContracts: action.Payload,
      };
    }
    case GET_CORRESPONDENCE: {
      return {
        ...state,
        Correspondences: action.Payload.BoardCorrespondences,
        TasksCorrespondences: action.Payload.TasksCorrespondences,
      };
    }
    case ADD_BOARD_CORRESPONDENCE: {
      return {
        ...state,
        Correspondences: [...state.Correspondences, action.Payload],
      };
    }
    case EDIT_BOARD_CORRESPONDENCE: {
      const Correspondences1 = state.Correspondences;
      const Find1 = Correspondences1.find(
        (item) => item._id === action.Payload._id
      );
      const IndexOf1 = Correspondences1.indexOf(Find1);
      Correspondences1[IndexOf1] = action.Payload;
      return {
        ...state,
        Correspondences: [...Correspondences1],
      };
    }
    case DELETE_BOARD_CORRESPONDENCE: {
      const Correspondences2 = state.Correspondences;
      const Filter2 = Correspondences2.filter(
        (item) => item._id !== action.Payload
      );
      return {
        ...state,
        Correspondences: [...Filter2],
      };
    }
    default: {
      return state;
    }
  }
};
